/* Utils */
import { createDeferredPromise } from '../../createDeferredPromise';
import importScript from '../../importScript';
import { titanOsTvModels, zeasnUrlDGO, zeasnUrlSkymais } from '../../env';

const titanBlackList = ['titanos/1\\.0', 'titanos/3\\.0', ...titanOsTvModels];
const zeansPatterns = ['whaletv', 'wh1\\.0', 'nettv', 'tbrowser/2\\.0', 'sraf/3\\.5'];

const blackListRegex = titanBlackList.join('|');
const zeansRegex = zeansPatterns.join('|');

const combinedRegex = new RegExp(`^(?!.*(?:${blackListRegex})).*(${zeansRegex})`, 'i');

const verifyUrlProd = () => {
  if (zeasnUrlDGO && zeasnUrlSkymais) {
    return window.location.origin.includes(zeasnUrlDGO)
    || window.location.origin.includes(zeasnUrlSkymais);
  }
  return false;
};

export function isZeasn() {
  // Check code https://cache.zeasn.tv/webstatic/homepage_web/deviceinfo/zeasn_deviceInfo_sdk.js

  // Check docs https://partner.zeasn.com/partnerportal/WhaleVersion1/index.jhtml
  // and https://partner.zeasn.com/partnerportal/sdk/index.jhtml
  return verifyUrlProd() || !!window.SmartTvA_API || combinedRegex.test(navigator.userAgent);
}

const DEVICE_INFO_SDK_URL = 'https://cache.zeasn.tv/webstatic/homepage_web/deviceinfo/zeasn_deviceInfo_sdk.js';
let deviceInfoSdkPromise;
export function importDeviceInfoSdk() {
  if (!deviceInfoSdkPromise) {
    deviceInfoSdkPromise = importScript(DEVICE_INFO_SDK_URL);
  }
  return deviceInfoSdkPromise;
}

let deviceInfoDeferred;
export async function getDeviceInfo() {
  if (deviceInfoDeferred) return deviceInfoDeferred.promise;

  deviceInfoDeferred = createDeferredPromise();

  await importDeviceInfoSdk();

  window.onDeviceInfoReady((info) => {
    let sdkVersion;
    if (/wh1\.0|nettv|tbrowser\/2\.0|sraf\/3\.5/i.test(navigator.userAgent)) {
      sdkVersion = '1.0';
    } else {
      [, sdkVersion] = /whaletv\/([\d.]+)/i.exec(navigator.userAgent) || [];
    }
    const {
      Product: { firmwareVersion, platform } = {},
      Capability: { supportUHD, supportHDR } = {},
    } = info || {};
    deviceInfoDeferred.resolve({
      version: firmwareVersion,
      sdkVersion: sdkVersion || firmwareVersion,
      modelName: platform,
      uhd: supportUHD,
      hdr: supportHDR,
    });
  });

  return deviceInfoDeferred.promise;
}
